<button (click)="modalDelete()" type="button" title="Excluir esse item do carrinho.">
  <img src="/images/icons/aextour/carrinho/delete.svg" alt="Deletar Item" />
  <span>EXCLUIR</span>
</button>
  